import SchemaCollection from "./SchemaCollection";
import state from "../vue/CourseFlow/state";

export default class StateGuard {
    constructor(state) {
        this.state = state.value;
    }

    getMaxStep() {
        const isStep10CompleteAndValid = this.checkStep10();
        const isStep20CompleteAndValid = this.checkStep20();
        console.log(isStep10CompleteAndValid, isStep20CompleteAndValid);
        if (isStep10CompleteAndValid && isStep20CompleteAndValid) {
            return 30;
        }

        if (isStep10CompleteAndValid) {
            return 20;
        }

        return 10;
    }

    checkStep10() {
        if (this.state.participants.length > 0) {
            let validState = true;
            this.state.participants.forEach((participant) => {
                if (SchemaCollection.participant.isValidSync(participant) === false) {
                    validState = false;
                }
            })

            return validState;
        }

        return false;
    }

    checkStep20() {
        if (this.state.invoiceContact) {
            if (this.state.invoicePerson === 'self') {
                return SchemaCollection.participant.isValidSync(this.state.invoiceContact);
            }

            return SchemaCollection.invoice.isValidSync(this.state.invoiceContact);
        }

        return false;
    }
}